
$(".collapsible-trigger").on('click', function() {
    var content = $(this).parents(".collapsible").first().find('.collapsible-content');
    var minHeight = content.css("min-height");
    if (content.hasClass('active')){
        content.css('max-height', "0px");
        content.removeClass('active');
        $('.collapsible-disable').addClass('hidden');
        $('.collapsible-enable').removeClass('hidden');
    } else {
        content.css('max-height', content.prop('scrollHeight') + "px");
        content.addClass('active');
        $('.collapsible-disable').removeClass('hidden');
        $('.collapsible-enable').addClass("hidden");
    } 
})

$('#expert').on('change', function() {
    var url = window.location.href;   
    console.log(window.location);
    if (url.indexOf('?') > -1){
        sep = '&'
    } else{
        sep = '?'
    }
    if ($(this).is(":checked")) {
        url += sep + "is_expert=1";
    } else {
        url = url.replace('&is_expert=1', '');
        url = url.replace('?is_expert=1', '');
    }
    console.log(url);
    window.location.replace(url);
});